(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hikari-footer"]) return;
  try {
    
// Only the *starting* open/closed state is scripted here — the disclosure
// interaction itself is native <details> behaviour (keyboard included).
// Starts collapsed on mobile (saves scroll length), open on desktop
// (matches how it always looked there). Re-evaluates on resize so rotating
// a tablet or resizing a window doesn't leave it stuck in the wrong state.
(function () {
  var mq = window.matchMedia('(min-width: 900px)');
  function sync() {
    document.querySelectorAll('[data-ftr-group]').forEach(function (el) {
      el.open = mq.matches;
    });
  }
  sync();
  mq.addEventListener('change', sync);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hikari-hero"] && !Shopify.designMode) return;
  try {
    
class HikariHeroSlides extends HTMLElement {
  connectedCallback() {
    this.radios = Array.from(this.querySelectorAll('.hh__radio'));
    if (this.radios.length < 2) return;
    this.#setupAutoplay();
  }

  disconnectedCallback() {
    this.#stop();
    this.motionQuery?.removeEventListener('change', this.onMotionChange);
  }

  #setupAutoplay() {
    const root = this.querySelector('.hh');
    if (!root || root.dataset.autoplay !== 'true') return;
    const seconds = parseFloat(root.dataset.autoplayDelay);
    this.delay = (Number.isFinite(seconds) && seconds > 0 ? seconds : 6) * 1000;
    this.pausedByUser = false;
    this.timer = null;

    this.pauseButton = this.querySelector('[data-hh-pause]');
    if (this.pauseButton) {
      this.pauseButton.hidden = false;
      this.pauseLabelEl = this.pauseButton.querySelector('[data-hh-pause-label]');
      this.pauseButton.addEventListener('click', () => {
        this.pausedByUser = !this.pausedByUser;
        this.pauseButton.setAttribute('aria-pressed', String(this.pausedByUser));
        if (this.pauseLabelEl) {
          const { pauseLabel, playLabel } = this.pauseButton.dataset;
          this.pauseLabelEl.textContent = this.pausedByUser ? playLabel : pauseLabel;
        }
        if (this.pausedByUser) this.#stop(); else this.#start();
      });
    }

    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onMotionChange = () => { if (this.motionQuery.matches) this.#stop(); else this.#start(); };
    this.motionQuery.addEventListener('change', this.onMotionChange);

    this.addEventListener('pointerenter', () => this.#stop());
    this.addEventListener('pointerleave', () => this.#start());
    this.addEventListener('focusin', () => this.#stop());
    this.addEventListener('focusout', () => { if (!this.contains(document.activeElement)) this.#start(); });

    document.addEventListener('visibilitychange', () => { if (document.hidden) this.#stop(); else this.#start(); });

    this.radios.forEach((radio) => radio.addEventListener('change', () => this.#restart()));

    this.#start();
  }

  #start() {
    if (!this.delay || this.timer || this.pausedByUser) return;
    if (this.motionQuery?.matches || document.hidden) return;
    this.timer = setInterval(() => this.#advance(), this.delay);
  }

  #stop() {
    if (!this.timer) return;
    clearInterval(this.timer);
    this.timer = null;
  }

  #restart() { this.#stop(); this.#start(); }

  #advance() {
    const current = this.radios.findIndex((r) => r.checked);
    const next = (current + 1) % this.radios.length;
    this.radios[next].checked = true;
    this.radios[next].dispatchEvent(new Event('change', { bubbles: true }));
  }
}
customElements.define('hikari-hero-slides', HikariHeroSlides);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hikari-product-row"] && !Shopify.designMode) return;
  try {
    
class HikariProductRow extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', (event) => this.#handleSubmit(event));
  }

  async #handleSubmit(event) {
    const form = event.target.closest('[data-hpr-add-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[data-hpr-add-btn]');
    if (!button || button.disabled) return;
    button.disabled = true;
    try {
      const response = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('add to cart failed');
      await response.json();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      button.setAttribute('data-added', '');
      button.textContent = button.dataset.addedLabel;
      setTimeout(() => {
        button.removeAttribute('data-added');
        button.textContent = button.dataset.idleLabel;
        button.disabled = false;
      }, 1800);
    } catch (error) {
      button.disabled = false;
      form.submit();
    }
  }
}
customElements.define('hikari-product-row', HikariProductRow);
document.querySelectorAll('.hpr').forEach((root) => {
  if (root.closest('hikari-product-row')) return;
  const wrapper = document.createElement('hikari-product-row');
  const parent = root.parentNode;
  const nextSibling = root.nextSibling;
  wrapper.appendChild(root);
  parent.insertBefore(wrapper, nextSibling);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
